module.exports = __webpack_public_path__ + "img/wrong.60799c52.svg";